import axiosInstance from "@/api/axiosInstance";
import { FavoritesKeyResponse } from "./types";

export const getFavoritesKey = async (): Promise<FavoritesKeyResponse> => {
  const response = await axiosInstance.get<FavoritesKeyResponse>(
    "/api/search/favorites-key"
  );
  return response.data;
};